/**
 * Dairy plant records — stored by the Spring Boot API.
 */
import { api, qs } from './http';

function call<T = any>(path: string, options: RequestInit = {}) {
  return api<T>(path, options);
}

export const dairyMockApi = {
  getSuppliers: () => call('/api/dairy/suppliers'),
  createSupplier: (data: Record<string, unknown>) =>
    call('/api/dairy/suppliers', { method: 'POST', body: JSON.stringify(data) }),
  updateSupplier: (id: string, data: Record<string, unknown>) =>
    call(`/api/dairy/suppliers/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  getCenters: () => call('/api/dairy/centers'),
  createCenter: (data: Record<string, unknown>) =>
    call('/api/dairy/centers', { method: 'POST', body: JSON.stringify(data) }),
  getRoutes: () => call('/api/dairy/routes'),
  createRoute: (data: Record<string, unknown>) =>
    call('/api/dairy/routes', { method: 'POST', body: JSON.stringify(data) }),

  getRateCharts: () => call('/api/dairy/rate-charts'),
  getActiveRateChart: (date?: string) => call(`/api/dairy/rate-charts/active${qs({ date })}`),
  saveRateChart: (data: Record<string, unknown>) =>
    call('/api/dairy/rate-charts', { method: 'POST', body: JSON.stringify(data) }),
  previewRate: (fat: number, snf: number, date?: string) =>
    call('/api/dairy/rate-preview', { method: 'POST', body: JSON.stringify({ fat, snf, date }) }),

  getCollections: (filters?: { date?: string; shift?: string }) =>
    call(`/api/dairy/collections${qs({ date: filters?.date, shift: filters?.shift })}`),
  createCollection: (data: Record<string, unknown>) =>
    call('/api/dairy/collections', { method: 'POST', body: JSON.stringify(data) }),
  cancelCollection: (id: string) =>
    call(`/api/dairy/collections/${id}/cancel`, { method: 'POST' }),

  getPurchaseLedger: (periodFrom?: string, periodTo?: string) =>
    call(`/api/dairy/ledger${qs({ from: periodFrom, to: periodTo })}`),
  getPayments: () => call('/api/dairy/payments'),
  createPayment: (data: Record<string, unknown>) =>
    call('/api/dairy/payments', { method: 'POST', body: JSON.stringify(data) }),
  updatePaymentStatus: (id: string, status: string, payment_mode?: string) =>
    call(`/api/dairy/payments/${id}/status`, {
      method: 'POST',
      body: JSON.stringify({ status, payment_mode }),
    }),
  generatePaymentsFromLedger: (periodFrom: string, periodTo: string) =>
    call('/api/dairy/payments/generate', {
      method: 'POST',
      body: JSON.stringify({ period_from: periodFrom, period_to: periodTo }),
    }),

  getProcessingBatches: () => call('/api/dairy/processing'),
  createProcessingBatch: (data: Record<string, unknown>) =>
    call('/api/dairy/processing', { method: 'POST', body: JSON.stringify(data) }),
  updateProcessingBatch: (id: string, data: Record<string, unknown>) =>
    call(`/api/dairy/processing/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  getPackingLots: () => call('/api/dairy/packing'),
  createPackingLot: (data: Record<string, unknown>) =>
    call('/api/dairy/packing', { method: 'POST', body: JSON.stringify(data) }),

  getDashboard: () => call('/api/dairy/dashboard'),
};

export type DairyMockApi = typeof dairyMockApi;
